import { render, staticRenderFns } from "./btn-info.vue?vue&type=template&id=9836532a&scoped=true"
import script from "./btn-info.vue?vue&type=script&lang=js"
export * from "./btn-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9836532a",
  null
  
)

export default component.exports